import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './WidgetCurrencyConverter.css';
import React from 'react';
import { get, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import FormField from './components/FormField';
import SelectField from './components/SelectField';
import { useHistory, useLocation } from 'react-router-dom';
import addQueryString from '../Listing';
import useMobile from './useMobile';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { runValidations, validateRequired } from './commomFunctions';
var WidgetCurrencyConverter = function WidgetCurrencyConverter(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var apiURL = typeof window !== 'undefined' ? window.location.origin : get(sitecoreContext, 'origin') || 'https://vdqa.testvisitdubai.com';

  // get(sitecoreContext, 'origin') || 'https://vdqa.testvisitdubai.com';
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var variables = BackgroundColorHex ? {
    "--m84-primary-color": BackgroundColorHex,
    "--m84-primary-active-color": ActiveColorHex,
    "--m84-color": ColorHex
  } : {
    "--m84-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m84-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m84-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var mainTitle = get(fields, 'data.datasource.title.jss.value');
  var otherCurrenciesTitle = get(fields, 'data.datasource.otherCurrenciesTitle.jss.value');
  var currencyTextTitle = get(fields, 'data.datasource.currencyText.jss.value');
  var convertCurrency = get(fields, 'data.datasource.convertCurrency.currency');
  var convertCurrencyTitle = get(convertCurrency, 'title.jss.value');
  var convertCurrencyIcon = get(convertCurrency, 'icon.jss.value.src');
  var convertCurrencyId = get(convertCurrency, 'currencyId.jss.value');
  var mainCurrenciesArray = get(fields, 'data.datasource.mainCurrencies.currencies');
  var otherConvertCurrenciesArray = get(fields, 'data.datasource.otherConvertCurrencies.currencies');
  var tableTitle = get(fields, 'data.datasource.tableTitle.jss.value');
  var tableText = get(fields, 'data.datasource.tableText.jss.value');
  var _get = get(fields, 'data.analytics.parameters', [{}]),
    _get2 = _slicedToArray(_get, 1),
    analytics = _get2[0];
  var tableRows = get(fields, 'data.datasource.tableRows');
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var isMobile = useMobile();
  var location = useLocation();
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    disableSubmit = _React$useState4[0],
    setDisableSubmit = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    formResponseError = _React$useState6[0],
    setFormResponseError = _React$useState6[1];
  var allErrors = [];
  var history = useHistory();
  var _React$useState7 = React.useState({
      mainCurrencyValue: '1',
      convertedCurrencyValue: '0'
    }),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    inputValue = _React$useState8[0],
    setInputValue = _React$useState8[1];
  var mainCurrencyValue = inputValue.mainCurrencyValue,
    convertedCurrencyValue = inputValue.convertedCurrencyValue;
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAllRatesLoaded = _React$useState10[0],
    setIsAllRatesLoaded = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    otherCurrenciesValueState = _React$useState12[0],
    setOtherCurrenciesValueState = _React$useState12[1];
  var _React$useState13 = React.useState({}),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    preselectedValue = _React$useState14[0],
    setPreselectedValue = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isMobileView = _React$useState16[0],
    setIsMobileView = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    allowRender = _React$useState18[0],
    setAllowRender = _React$useState18[1];
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setInputValue(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, name, value));
    });
  };
  var clearInput = function clearInput() {
    setInputValue(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        mainCurrencyValue: ''
      });
    });
  };
  var calculateRate = function calculateRate(rate, key) {
    var mainValue = inputValue.mainCurrencyValue;
    var res = Number(mainValue) * rate;
    if (rate) {
      setInputValue(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, key, "".concat(res.toFixed(2))));
      });
    }
  };
  React.useEffect(function () {
    if (mainCurrencyValue && Object.keys(preselectedValue).length !== 0) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [mainCurrencyValue, preselectedValue]);
  React.useEffect(function () {
    setIsMobileView(isMobile);
  }, [isMobile]);
  React.useEffect(function () {
    var countryCode = '';
    var queryParams = qsToObject(location.search);
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(function (item) {
        return item.indexOf('user_country_code') > -1;
      });
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
    }
    if (process.env.STORYBOOK_MODE) {
      countryCode = 'PK';
    }
    fetch("".concat(apiURL, "/api/currencyapi/getallcountries")).then(function (response) {
      if (response && response.status === 200) {
        return response.json();
      }
    }).then(function (response) {
      var defaultId = 'US';
      var codeForFiltering = countryCode ? countryCode : defaultId;
      var currentCountryItem = response.find(function (item) {
        return item.id === codeForFiltering;
      });
      var serverCountry = mainCurrenciesArray.find(function (item) {
        return item.currencyId.jss.value === currentCountryItem.currencyId;
      });
      if (countryCode === 'AE' || serverCountry === undefined) {
        setPreselectedValue({});
        setDisableSubmit(true);
      } else {
        setPreselectedValue(serverCountry);
      }
      mainCurrenciesArray.map(function (el) {
        el['label'] = el.title.jss.value;
        el['value'] = el.currencyId.jss.value;
      });
      var otherCurrenciesToState = [];
      otherConvertCurrenciesArray.forEach(function (el) {
        otherCurrenciesToState.push({
          id: "".concat(serverCountry ? serverCountry.value : '', "_").concat(el.currencyId.jss.value),
          currencyId: el.currencyId.jss.value,
          value: '0',
          loading: false,
          src: Object.keys(el.icon).length ? el.icon.jss.value.src : '',
          title: el.title.jss.value
        });
      });
      setOtherCurrenciesValueState(otherCurrenciesToState);
    }).then(function () {
      return setAllowRender(true);
    }).catch(function (e) {
      console.error(e);
    });
  }, []);
  var _React$useState19 = React.useState(''),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    errorMainCurrency = _React$useState20[0],
    setErrorMainCurrency = _React$useState20[1];
  var mainCurrencyFieldProps = {
    value: mainCurrencyValue,
    label: mapDictionary.get('amount'),
    fieldError: errorMainCurrency,
    setError: setErrorMainCurrency,
    type: 'number',
    id: convertCurrencyId,
    name: 'mainCurrencyValue',
    placeholder: '',
    labelLight: false,
    required: false,
    errorValue: 'validateRequired',
    changeEvent: function changeEvent(event) {
      handleChange(event);
    },
    blurEvent: function blurEvent(value) {
      mainCurrencyFieldProps.validate(value);
    },
    focusEvent: function focusEvent(value) {
      clearInput();
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mainCurrencyValue;
      return runValidations([validateRequired], value, mainCurrencyFieldProps);
    }
  };
  allErrors.push(mainCurrencyFieldProps);
  var mainCurrencySelectFieldProps = {
    value: Object.keys(preselectedValue).length ? {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, Object.keys(preselectedValue.icon.jss.value).length ? /*#__PURE__*/React.createElement("img", {
        alt: preselectedValue.icon.jss.value.alt,
        className: "select-item__image ".concat(Object.keys(preselectedValue.icon.jss.value).length ? '' : 'hidden'),
        src: preselectedValue.icon.jss.value.src
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, preselectedValue.title.jss.value)),
      title: isMobileView ? preselectedValue.currencyId.jss.value : preselectedValue.title.jss.value,
      value: preselectedValue.title.jss.value
    } : {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      })),
      title: '',
      value: ''
    },
    label: mapDictionary.get('currency'),
    id: 'main-currency-select',
    name: 'main-currency',
    labelLight: false,
    autoComplete: 'main-currency',
    required: false,
    changeEvent: function changeEvent(obj) {
      setPreselectedValue(obj);
      if (otherCurrenciesValueState.length) {
        var copy = _toConsumableArray(otherCurrenciesValueState);
        copy.forEach(function (el) {
          el.id = "".concat(obj.value, "_").concat(el.currencyId);
        });
        setOtherCurrenciesValueState(copy);
      }
    },
    blurEvent: function blurEvent(value) {},
    options: mainCurrenciesArray
  };

  // Validate all fields on submit
  var validateAllFields = function validateAllFields() {
    var success = true;
    for (var _i = 0, _allErrors = allErrors; _i < _allErrors.length; _i++) {
      var fieldObj = _allErrors[_i];
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    setFormResponseError('');
    if (validateAllFields()) {
      var preselectedValueTitle = get(preselectedValue, 'title.jss.value');
      tealiumClickFunc(tealiumMergeClickData(analytics, params), [preselectedValueTitle, convertCurrencyTitle]);
      var mainCurrencyId = preselectedValue.value;
      var _convertCurrencyId = convertCurrency.currencyId.jss.value;
      var mainValue = inputValue.mainCurrencyValue;
      var inputValueCopied = _toConsumableArray(otherCurrenciesValueState);
      var requestQueries = ["".concat(_convertCurrencyId)];
      var requestCount = Math.round(inputValueCopied.length / 2);
      for (var i = 0; i < requestCount; i++) {
        var step = 2;
        var index = i * step;
        var nextIndex = index + 1;
        var firstVal = void 0;
        var secondVal = void 0;
        if (inputValueCopied[index]) {
          firstVal = inputValueCopied[index].currencyId;
        }
        if (inputValueCopied[nextIndex]) {
          secondVal = inputValueCopied[nextIndex].currencyId;
        }
        var requestQuery = nextIndex !== inputValueCopied.length ? "".concat(firstVal, ",").concat(secondVal) : "".concat(firstVal);
        requestQueries.push(requestQuery);
      }
      Promise.all(requestQueries.map(function (query) {
        return fetch("".concat(apiURL, "/api/currencyapi/exchangerates?from=").concat(mainCurrencyId, "&to=").concat(query));
      })).then(function (responses) {
        setDisableSubmit(true);
        return Promise.all(responses.map(function (response) {
          if (response && response.status === 200) {
            addQueryString('from', mainCurrencyId, history);
            addQueryString('to', _convertCurrencyId, history);
            return response.json();
          } else {
            setFormResponseError("api error ".concat(response.status));
          }
        }));
      }).then(function (data) {
        setDisableSubmit(false);
        data.forEach(function (rate, index) {
          if (Object.keys(rate).length === 1 && Object.keys(rate)[0] === "".concat(mainCurrencyId, "_").concat(_convertCurrencyId)) {
            calculateRate(rate["".concat(mainCurrencyId, "_").concat(_convertCurrencyId)].val, 'convertedCurrencyValue');
          } else {
            Object.keys(rate).forEach(function (key) {
              var calculateRate = Number(mainValue) * rate["".concat(key)].val;
              var objIndex = inputValueCopied.findIndex(function (item) {
                return item.id === key;
              });
              if (objIndex !== -1) {
                inputValueCopied[objIndex].value = calculateRate.toFixed(2);
                inputValueCopied[objIndex].loading = false;
              }
            });
            setOtherCurrenciesValueState(function () {
              return inputValueCopied;
            });
          }
        });
      }).then(function (response) {
        if (Object.values(inputValueCopied).map(function (el) {
          return el.loading;
        }).filter(function (item) {
          return item === true;
        }).length === 0) {
          setIsAllRatesLoaded(true);
        }
        inputValueCopied.forEach(function (el) {
          el['loading'] = true;
        });
        setIsAllRatesLoaded(false);
      }).catch(function (error) {
        console.log(error);
      });
    }
  };
  if (!fields) {
    console.warn('WidgetCurrencyConverter component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[WidgetCurrencyConverter component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-10 currency-widget-centered",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title2"
  }, mainTitle), allowRender ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    className: "currency-widget__main-form",
    onSubmit: function onSubmit(event) {
      return _onSubmit(event);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement(FormField, mainCurrencyFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement(SelectField, mainCurrencySelectFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: " body-small form-label"
  }, mapDictionary.get('convertedAmount')), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__display-field"
  }, " ", convertedCurrencyValue)), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: " body-small form-label"
  }, mapDictionary.get('currency')), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__form-field-flag"
  }, convertCurrencyIcon && /*#__PURE__*/React.createElement("img", {
    className: "currency-widget__icon",
    src: convertCurrencyIcon,
    alt: convertCurrencyTitle
  }), /*#__PURE__*/React.createElement("span", null, isMobileView ? convertCurrencyId : convertCurrencyTitle)))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: disableSubmit,
    className: "btn btn-primary venue-shortlist__req-submit"
  }, mapDictionary.get('convert'))), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null, /*#__PURE__*/React.createElement("form", {
    action: "",
    className: "currency-widget__additional-form"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title4"
  }, otherCurrenciesTitle), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__columns"
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__additional-form-left"
  }, otherCurrenciesValueState.map(function (item) {
    var objIndex = otherCurrenciesValueState.findIndex(function (el) {
      return el.id === item.id;
    });
    var defaultVal = otherCurrenciesValueState.length && otherCurrenciesValueState[objIndex].value;
    return /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__column-field",
      key: "value_".concat(item.id)
    }, /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__display-field"
    }, isAllRatesLoaded ? item.value : defaultVal));
  })), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__additional-form-right"
  }, otherConvertCurrenciesArray.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__column-field",
      key: "flag_".concat(item.title.jss.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "currency-widget__form-field-flag"
    }, Object.keys(item.icon.jss.value).length ? /*#__PURE__*/React.createElement("img", {
      className: "currency-widget__icon",
      src: item.icon.jss.value.src,
      alt: item.icon.jss.value.src
    }) : null, /*#__PURE__*/React.createElement("span", null, isMobileView ? item.currencyId.jss.value : item.title.jss.value)));
  })))), /*#__PURE__*/React.createElement("p", {
    className: "currency-widget__form-notification"
  }, currencyTextTitle), /*#__PURE__*/React.createElement("div", {
    className: "currency-widget__table-header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title3"
  }, tableTitle), /*#__PURE__*/React.createElement("p", {
    className: "currency-widget__form-notification"
  }, tableText)), /*#__PURE__*/React.createElement("table", {
    className: "currency-widget__table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableItem'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('guidePrice')), /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableFirstCurrencyFull'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('tableFirstCurrencyShort')), /*#__PURE__*/React.createElement("th", null, mapDictionary.get('tableSecondCurrencyFull'), /*#__PURE__*/React.createElement("br", null), mapDictionary.get('tableSecondCurrencyShort')))), /*#__PURE__*/React.createElement("tbody", null, tableRows.map(function (rowData) {
    return /*#__PURE__*/React.createElement("tr", {
      key: rowData.title.jss.value
    }, /*#__PURE__*/React.createElement("td", null, rowData.title.jss.value), /*#__PURE__*/React.createElement("td", null, rowData.firstPrice.jss.value), /*#__PURE__*/React.createElement("td", null, rowData.secondPrice.jss.value));
  })))) : null)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c1m2tsl5";
var ltrStyles = "lh09v06";
var rtlStyles = "r1k79m0m";
export default WidgetCurrencyConverter;